import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';

class VendorApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/vendor');
  }

  protected transformNode(node: any) {
    node.vendorBrandOptionLabel = node.name + '(' + node.brands[0].name + ')';
    return node;
  }
}

export default VendorApiClient;
